import { combineReducers } from 'redux';
import {handleActions, createAction} from 'redux-actions';
import {createThunkActionCreator} from 'utils/redux/createThunkActionCreator';
import * as thunkActionConstants from 'utils/redux/thunkActionConstants';
import * as customersApi from 'services/api/auth';
import * as authConstants from './constants';

const forgotPasswordReducerMap = {};

export const forgotPasswordResetAction = createAction(authConstants.ACTION_FORGOT_PASSWORD_RESET);
forgotPasswordReducerMap[authConstants.ACTION_FORGOT_PASSWORD_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const forgotPasswordRequestAction = createThunkActionCreator(authConstants.ACTION_FORGOT_PASSWORD_REQUEST, (ssn4Digits, email) => {
  return customersApi.forgotPassword(ssn4Digits, email);
});

forgotPasswordReducerMap[authConstants.ACTION_FORGOT_PASSWORD_REQUEST] = (state, action) => {
  let failReason;
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {...action};
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {state, ...action};
    case thunkActionConstants.ACTION_STATUS_FAIL:
      failReason = authConstants.FAIL_REASON_NOT_FOUND;

      switch(action.error.code) {
        case authConstants.FAIL_ERROR_CODE_EXISTS:
          failReason = authConstants.FAIL_REASON_ALREADY_EXISTS;
          break;
        case authConstants.FAIL_ERROR_CODE_LOCKED:
          failReason = authConstants.FAIL_REASON_LOCKED;
          break;
      }
      return {state, ...action, failReason};
  }
};

const registerReducerMap = {};
export const registerResetAction = createAction(authConstants.ACTION_REGISTER_RESET);
registerReducerMap[authConstants.ACTION_REGISTER_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const registerRequestAction = createThunkActionCreator(authConstants.ACTION_REGISTER_REQUEST, (ssn4Digits, email) => {
  return customersApi.registerAccount(ssn4Digits, email);
});

registerReducerMap[authConstants.ACTION_REGISTER_REQUEST] = (state, action) => {
  let failReason;
  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {...action};
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {state, ...action};
    case thunkActionConstants.ACTION_STATUS_FAIL:
      failReason = authConstants.FAIL_REASON_NOT_FOUND;

      switch(action.error.code) {
        case authConstants.FAIL_ERROR_CODE_EXISTS:
          failReason = authConstants.FAIL_REASON_ALREADY_EXISTS;
          break;
        case authConstants.FAIL_ERROR_CODE_LOCKED:
          failReason = authConstants.FAIL_REASON_LOCKED;
          break;
      }
      return {state, ...action, failReason};
  }
};

const resetPasswordReducerMap = {};
export const resetPasswordResetAction = createAction(authConstants.ACTION_RESET_PASSWORD_RESET);
resetPasswordReducerMap[authConstants.ACTION_RESET_PASSWORD_RESET] = (state, action) => {
  return {
    ...action
  };
};

export const resetPasswordRequestAction = createThunkActionCreator(authConstants.ACTION_RESET_PASSWORD_REQUEST, (email, temporaryPassword, newPassword) => {
  return customersApi.resetPassword(email, temporaryPassword, newPassword);
});

resetPasswordReducerMap[authConstants.ACTION_RESET_PASSWORD_REQUEST] = (state, action) => {
  const {payload, ...rest} = action;
  let failReason;

  switch(action.status) {
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {...action};
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {state, ...rest, ...payload};
    case thunkActionConstants.ACTION_STATUS_FAIL:
      failReason = authConstants.FAIL_REASON_NOT_FOUND;

      switch(action.error.code) {
        case authConstants.FAIL_ERROR_CODE_LOCKED:
          failReason = authConstants.FAIL_REASON_LOCKED;
          break;
      }
      return {state, ...action, failReason};
  }
};


export const reducer = combineReducers({
  forgotPassword: handleActions(forgotPasswordReducerMap, {}),
  register: handleActions(registerReducerMap, {}),
  resetPassword: handleActions(resetPasswordReducerMap, {}),
});



// WEBPACK FOOTER //
// ./src/auth/redux.js